<template>
  <div>
    <b-row
      :style="
        `background-color:${screen.bgColor}; border-radius: 25px; height: 50vh`
      "
    >
      <b-col cols>
        <div id="roomContainer" style="height: 500px;" />
        <div id="publisher" />
        <div
          id="publisherScreenShare"
          style="height: 100px; border-radius: 25px"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <session-controls
          :is-av-avail="isAVSetUp"
          :is-session-avail="isAuthToJoinRoom"
          :toggle="toggle"
          :av-resources="avResources"
          @button-toggle="handleButtonToggle"
          @leave-room-click="handleLeaveRoom"
        />
        <b-row style="margin-top: 15px">
          <b-col>
            <b-button
              pill
              variant="warning"
              :disabled="!stageRoomId"
              @click="handleSetUpRoom"
            >
              Set Up Room
            </b-button>
          </b-col>
          <b-col>
            <b-button
              pill
              variant="warning"
              :disabled="!isRoomAvail || !isAVSetUp"
              @click="handleStartSessionClick"
            >
              Start Session
            </b-button>
          </b-col>
          <b-col>
            <b-button
              pill
              variant="warning"
              :disabled="!stageRoomId"
              @click="resizePublisher"
            >
              Resize
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <session-status
          :session="session"
          :profile="profile"
          :session-status="status"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import firebase from "firebase";
import { getDevices, Room } from "@vonage/video-express";
import SessionControls from "./controls";
import SessionStatus from "./status";
export default {
  name: "Sessions_Stage",
  components: {
    SessionControls,
    SessionStatus
  },
  props: {
    session: {
      type: Object,
      default: () => {}
    },
    profile: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {},
  computed: {
    isRoomAvail() {
      return !!(this.roomData.apiKey && this.roomData.sessionId);
    },
    isAVSetUp() {
      return !!(
        this.avResources.selectedAudio && this.avResources.selectedVideo
      );
    },
    isAuthToJoinRoom() {
      return !!this.roomData.token;
    },
    isScreenSharing() {
      return !!(
        this.room &&
        this.room.screen &&
        this.room.screen.isScreenSharing
      );
    }
  },
  methods: {
    handleSettingsPopOverClick() {
      this.showMenuPopover = !this.showMenuPopover;
    },
    handleAddDataButtonClick() {
      this.$emit("add-data-click");
    },
    handleSetUpRoom() {
      this.handleCreateRoom()
        .then(resp1 => {
          console.log(resp1);
          this.handleAVRequestAccess()
            .then(resp2 => {
              console.log(resp2);
              if (
                resp2 &&
                this.avResources.selectedVideo &&
                this.avResources.selectedAudio
              ) {
                console.log("made it here");
              }
            })
            .catch(err => {
              console.error("Error");
            });
        })
        .catch(err => {
          console.error(`Not able to create room: ${JSON.stringify(err)}`);
        });
    },
    handleCreateRoom() {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        this.roomRef = db.doc(`rooms/${this.stageRoomId}`);
        console.log("Room name: ", this.stageRoomId);
        this.status.roomStatus = "Creating the room...";
        return this.roomRef
          .get()
          .then(doc => {
            if (doc.exists) {
              this.roomRef
                .update({
                  _updated_at: new Date()
                })
                .then(() => {
                  this.status.roomStatus = `Room Exists!`;
                  return this.subscribeToRoom(this.stageRoomId)
                    .then(resp => {
                      res(resp);
                    })
                    .catch(err => {
                      rej(err);
                    });
                });
            } else {
              this.roomRef
                .set({
                  _created_at: new Date(),
                  apiKey: "",
                  sessionId: ""
                })
                .then(() => {
                  this.status.roomStatus = `Room Created!`;
                  return this.subscribeToRoom(this.stageRoomId)
                    .then(resp => {
                      res(resp);
                    })
                    .catch(err => {
                      rej(err);
                    });
                });
            }
          })
          .catch(error => {
            console.error("Error creating room: ", error);
            this.status.roomStatus = "Error creating room!";
          });
      });
    },
    subscribeToRoom() {
      return new Promise((res, rej) => {
        this.unsubRoom = this.roomRef.onSnapshot(doc => {
          let data = doc.data();
          console.log("Room Subscription Data: ", data);

          if (data.apiKey !== "" && data.sessionId !== "") {
            //this take time to create- bottle neck
            //Set Data
            this.roomData.apiKey = data.apiKey;
            this.roomData.sessionId = data.sessionId;
            this.status.roomStatus = `Room Subsribed To!`;
            res(this.roomData);
          } else {
            rej({ error: "Room does not exist" });
          }
        });
      });
    },
    async handleAVRequestAccess() {
      let resourcesLoaded = await this.loadAVSource();
      return new Promise((res, rej) => {
        if (resourcesLoaded) {
          res(true);
        } else {
          rej(false);
        }
      });
    },
    async loadAVSource() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        console.log("enumerateDevices() not supported.");
        return;
      }
      try {
        // Need to ask permission in order to get access to the devices to be able to list them in the dropdowns.
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: true
        });
        stream.getTracks().forEach(track => track.stop());
        let audioCount = 0;
        let videoCount = 0;
        const devices = await getDevices();

        devices.forEach(device => {
          if (device.kind.toLowerCase() === "audioinput") {
            audioCount++;

            let optAudio = {
              text: device.label || ` ${device.kind}  ${audioCount}`,
              value: device.deviceId
            };
            this.avResources.optsAudio.push(optAudio);
          }

          if (device.kind.toLowerCase() === "videoinput") {
            videoCount++;
            let optVideo = {
              text: device.label || ` ${device.kind}  ${videoCount}`,
              value: device.deviceId
            };
            this.avResources.optsVideo.push(optVideo);
          }
        });

        //Set Default Source
        this.avResources.selectedAudio =
          this.avResources.optsAudio &&
          Array.isArray(this.avResources.optsAudio) &&
          this.avResources.optsAudio.length > 0 &&
          this.avResources.optsAudio[0] &&
          this.avResources.optsAudio[0].value
            ? this.avResources.optsAudio[0].value
            : null;
        this.avResources.selectedVideo =
          this.avResources.optsVideo &&
          Array.isArray(this.avResources.optsVideo) &&
          this.avResources.optsVideo.length > 0 &&
          this.avResources.optsVideo[0] &&
          this.avResources.optsVideo[0].value
            ? this.avResources.optsVideo[0].value
            : null;
        return true;
      } catch (error) {
        console.error("error loading AV sources: ", error);
      }
      return false;
    },
    /*STEP 2 - JOINING */
    handleStartSessionClick() {
      //determine if crew or particpant
      this.handleJoinRoom();
    },
    handleJoinRoom() {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //@TODO-Move to single place
        this.participantRef = db.doc(
          `rooms/${this.stageRoomId}/participants/${this.participantName}`
        );

        return this.participantRef
          .get()
          .then(doc => {
            if (doc.exists) {
              this.participantRef
                .update({
                  _updated_at: new Date()
                })
                .then(() => {
                  return this.subscribeToParticipant(this.stageRoomId)
                    .then(resp => {
                      res(resp);
                    })
                    .catch(err => {
                      rej(err);
                    });
                });
            } else {
              this.participantRef
                .set({
                  _created_at: new Date(),
                  token: ""
                })
                .then(() => {
                  return this.subscribeToParticipant(this.stageRoomId)
                    .then(resp => {
                      res(resp);
                    })
                    .catch(err => {
                      rej(err);
                    });
                });
            }
          })
          .catch(err => {
            console.error("Error joining participant: ", err);
            rej(err);
          });
      });
    },
    subscribeToParticipant() {
      //unsubP- @Todo- need different subscriptions?
      return new Promise((res, rej) => {
        this.unsubUser = this.participantRef.onSnapshot(doc => {
          let data = doc.data();
          console.log("Current data: ", data);
          if (data.token !== "") {
            this.roomData.token = data.token;
            //Not connected here
            if (this.avResources.previewPublisher) {
              this.avResources.previewPublisher.destroy();
            }
          }
        });
        res(true);
      });
    },
    async joinRoom() {
      return new Promise(async (res, rej) => {
        console.log("joinRoom room: ", this.room);

        if (!this.room) {
          console.log("create a new room");
          this.room = new Room({
            apiKey: this.roomData.apiKey, // add your OpenTok APIKey
            sessionId: this.roomData.sessionId, // add your OpenTok Session Id
            token: this.roomData.token, // add your OpenTok token
            participantName: this.roomData.participantName,
            roomContainer: "roomContainer",
            managedLayoutOptions: {
              cameraPublisherContainer: "publisher"
            }
          });
        }

        const { camera, screen } = this.room;

        this.camera = camera;

        debugger;
        const publisherOptions = {
          insertMode: "append",
          width: "100%",
          height: "100%"
        };

        //this.publisher = camera.initPublisher('publisher', publisherOptions);

        try {
          let pubProps = {
            resolution: "1280x720",
            [this.avResources.selectedAudio === ""
              ? "publishAudio"
              : "audioSource"]:
              this.avResources.selectedAudio === ""
                ? false
                : this.avResources.selectedAudio,
            [this.avResources.selectedVideo === ""
              ? "publishVideo"
              : "videoSource"]:
              this.avResources.selectedVideo === ""
                ? false
                : this.avResources.selectedVideo,
            mirror: true,
            audioBitrate: 6000,
            audioFallbackEnabled: true
          };
          await this.room.join({
            publisherProperties: pubProps
          });
        } catch (error) {
          rej(error);
          console.error("Error joining room: ", error)``;
        }

        this.status.isAudioEnabled = this.camera.isAudioEnabled()
          ? true
          : false;
        this.status.isVideoEnabled = this.camera.isVideoEnabled()
          ? true
          : false;

        screen.on("started", () => {
          this.toggle.isScreenSharing = true;
          console.log("The screen sharing has started!");
        });

        screen.on("stopped", () => {
          this.toggle.isScreenSharing = false;
          console.log("The screen stopped sharing because: ");
        });

        this.room.on("connected", async () => {
          console.log("room connected!");
        });

        this.room.on("participantJoined", participant => {
          console.log("participantJoined: ", participant);
          participant.on("cameraCreated", cameraSubscriber => {
            console.log("Participant camera created! ", cameraSubscriber);
          });
          participant.on("cameraDestroyed", reason => {
            console.log("Participant camera destroyed!", reason);
          });
          participant.on("screenCreated", screenSubscriber => {
            console.log("Participant Screen created!", screenSubscriber);
          });
          participant.on("screenDestroyed", reason => {
            console.log("Participant Screen destroyed!", reason);
          });
          participant.on("destroyed", reason => {
            console.log("Participant Screen destroyed!", reason);
          });
        });

        this.room.on("disconnected", () => {
          console.log("room disconnected!");
        });

        this.room.on("reconnecting", () => {
          console.log("room reconnecting!");
        });

        this.room.on("reconnected", () => {
          console.log("room reconnected!");
        });

        res(true);
      });
    },
    /** CONTROLS **/
    handleButtonToggle(toggleItem) {
      switch (toggleItem) {
        case "audio":
          this.handleToggleAudio();
          break;
        case "video":
          this.handleToggleVideo();
          break;
        case "layout":
          this.handleToggleLayout();
          break;
        case "hand":
          this.handleToggleHandRaise();
          break;
        case "settings":
          this.handleToggleSettings();
          break;
        case "screenshare":
          this.handleToggleScreenShare();
          break;
        default:
          break;
      }
    },
    handleToggleVideo() {
      if (this.camera) {
        console.log("camera.isVideoEnabled()", this.camera.isVideoEnabled());

        if (this.camera.isVideoEnabled()) {
          this.camera.disableVideo();
          this.status.isVideoEnabled = false;
        } else {
          this.camera.enableVideo();
          this.status.isVideoEnabled = true;
        }
      }
    },
    handleToggleAudio() {
      if (this.camera) {
        if (this.camera.isAudioEnabled()) {
          this.camera.disableAudio();
          this.status.isAudioEnabled = false;
        } else {
          this.camera.enableAudio();
          this.status.isAudioEnabled = true;
        }
      }
    },
    handleToggleLayout() {
      if (this.camera) {
        console.log(`Layout Status is  ${this.status.layoutStatus}`);
        if (this.status.layoutStatus === "grid") {
          this.room.setLayoutMode("active-speaker");
          this.status.layoutStatus = "active speaker";
        } else {
          this.room.setLayoutMode("grid");
          this.status.layoutStatus = "grid";
        }
      }
    },
    handleToggleHandRaise() {},
    handleToggleSettings() {
      this.toggle.showSettings = !this.toggle.showSettings;
    },
    handleToggleScreenShare() {
      if (this.isScreenSharing) {
        this.room.stopScreensharing();
      } else {
        this.room.startScreensharing("publisherScreenShare");
      }
    },
    handleLeaveRoom() {
      debugger;
      if (this.room) {
        this.roomData.token = null;
        this.room.token = null;
        this.room.leave();
      }
    },
    resizePublisher() {
      this.publisherContainer.style.width = "1000px";
      this.publisherContainer.style.height = "750px";
    }
  },
  watch: {
    isAuthToJoinRoom(valNew, valOld) {
      if (valNew === true) {
        this.joinRoom();
      }
    }
  },
  data() {
    return {
      showMenuPopover: false,
      screen: {
        bgColor: "#222222"
      },
      room: null,
      roomRef: "",
      participantRef: "",
      stageRoomId: this.session && this.session.id ? this.session.id : null,
      roomData: {
        apiKey: null,
        sessionId: null,
        token: null,
        participantName: null
      },
      avResources: {
        optsAudio: [],
        optsVideo: [],
        selectedAudio: null,
        selectedVideo: null,
        previewPublisher: null
      },
      participantName:
        this.profile && this.profile.firstname ? this.profile.firstname : null,
      toggle: {
        showSettings: false
      },
      status: {
        isVideoEnabled: null,
        isAudioEnabled: null,
        roomStatus: null,
        layoutStatus: ""
      },
      camera: null,
      unsubRoom: null,
      unsubUser: null,
      publisher: null
    };
  }
};
</script>

<style lang="scss" scoped>
.update-profile-btn {
  position: absolute;
  left: 0%;
  bottom: 80%;
  cursor: pointer;
  width: 100%;
  border-radius: 25px;
}

#publisher {
  width: 100px;
  height: 100px;
}
@media screen and (max-width: 650px) {
  #publisher {
    width: 89px;
    height: 50px;
  }
}
</style>
